module.exports = __webpack_public_path__ + "976f14a74a47d07e33e24ebdece17619.pdf";